function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 30.9987C24.2843 30.9987 31 24.283 31 15.9987C31 7.71445 24.2843 0.998718 16 0.998718C7.71573 0.998718 1 7.71445 1 15.9987C1 24.283 7.71573 30.9987 16 30.9987Z",
  fill: "#FDF5D8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0007 19.0001C16.0996 19.0001 16.1962 19.0294 16.2784 19.0844C16.3607 19.1393 16.4248 19.2174 16.4626 19.3088C16.5004 19.4001 16.5103 19.5007 16.491 19.5977C16.4718 19.6946 16.4241 19.7837 16.3542 19.8537C16.2843 19.9236 16.1952 19.9712 16.0982 19.9905C16.0012 20.0098 15.9007 19.9999 15.8093 19.962C15.718 19.9242 15.6399 19.8601 15.5849 19.7779C15.53 19.6957 15.5007 19.599 15.5007 19.5001C15.5007 19.3675 15.5533 19.2403 15.6471 19.1466C15.7409 19.0528 15.8681 19.0001 16.0007 19.0001Z",
  fill: "#D9B536",
  stroke: "#D9B536",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0007 16.0001V12.0002",
  stroke: "#D9B536",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7512 19.5761C23.9317 19.9367 24.017 20.3376 23.999 20.7405C23.9809 21.1434 23.8602 21.5351 23.6481 21.8782C23.4361 22.2213 23.1398 22.5044 22.7875 22.7008C22.4352 22.8971 22.0386 23.0001 21.6352 23H10.3661C9.96277 23.0001 9.56611 22.8971 9.2138 22.7008C8.86149 22.5044 8.56525 22.2213 8.35322 21.8782C8.14118 21.5351 8.02041 21.1434 8.00237 20.7405C7.98433 20.3376 8.06962 19.9367 8.25014 19.5761L13.8847 8.30826C14.0811 7.91517 14.3831 7.58456 14.7568 7.35348C15.1305 7.1224 15.5613 7 16.0007 7C16.4401 7 16.8708 7.1224 17.2445 7.35348C17.6183 7.58456 17.9203 7.91517 18.1166 8.30826L23.7512 19.5761Z",
  stroke: "#D9B536",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgToastWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarning);
export default __webpack_public_path__ + "static/media/toast-warning.6d9c3f6b.svg";
export { ForwardRef as ReactComponent };